import { Component } from '@angular/core';

@Component({
  selector: 'app-alarm-player',
  template: `<audio
    id="alarm-player"
    src="assets/sounds/alarm.mp3"
    preload="auto">
  </audio>`
})
export class AlarmPlayerComponent {}
